import React, { FC, BaseHTMLAttributes } from "react";

import classNames from "classnames";

import { StyledBackLink } from "./Styles";

export interface IBackLinkProps extends BaseHTMLAttributes<HTMLAnchorElement> {
  /** Children type of node or string */
  children: string;
  /** CSS classes */
  className?: string;
}
/**
 * Back link component
 */
export const BackLink: FC<IBackLinkProps> = ({
  children,
  className,
  ...args
}) => {
  return (
    <StyledBackLink className={classNames("c-back-link", className)} {...args}>
      {children}
    </StyledBackLink>
  );
};

BackLink.displayName = "BackLink";
